import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import './VideoPlayback.scss';

export function VideoPlayback({ src, title }) {
  return (
    <FormattedMessage id="sr_video_title" values={{ title }}>
      {titleAttr => (
        <iframe
          className="cp-ugc-video-playback"
          data-key="ugc-video-playback"
          src={src}
          frameBorder="0"
          allowFullScreen
          title={titleAttr}
        />
      )}
    </FormattedMessage>
  );
}

VideoPlayback.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default VideoPlayback;
